import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class CostanalysisVendorDetailService {
    private _Cost1099ServiceReportUrl = CONFIGURATION.baseServiceUrl + 'vendorcostanalysisreportservice/';
    constructor(private _http: Http) { }

    getAllRecods(vendorname: any, companyname: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.get(this._Cost1099ServiceReportUrl + 'getvendordetails?VendorName=' + vendorname +
            '&CompanyName=' + companyname,
            { headers: headers })
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
    }

    getReportData(data: any): Observable<any> {
        const headers = new Headers();
        headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
        headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
        return this._http.post(this._Cost1099ServiceReportUrl + `v2/vendorcostanalysisreportdata`,data, { headers: headers })
          .map((res: Response) => res.json())
      }
}



// WEBPACK FOOTER //
// ./src/app/costanalysisvendordetail/costanalysisvendordetail.service.ts